export default "__VITE_ASSET__9bfe059f__"